import React from "react";

export const ThemeContext = React.createContext({
  dark: false,
  toggle: () => {},
});
